import { Component, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'qumra-search-input',
  styleUrl: 'qumra-search-input.css',
  shadow: true,
})
export class QumraSearchInput {
  @State() searchValue: string = '';
  @Prop() searchOpen: boolean; 

  toggleSearch = () => {
    this.searchOpen = !this.searchOpen;
  };

  Search = () => {
    const url = `/search/?q=${this.searchValue}`;
    window.location.href = url;
  };

  handleInputChange = (event: Event) => {
    const target = event.target as HTMLInputElement;
    this.searchValue = target.value;
  };

  preventClose = (event: Event) => {
    event.stopPropagation(); 
  };

  render() {
    return (
      <div
        class={` qumra-search-container ${this.searchOpen ? 'qumra-fixed qumra-flex' : 'qumra-hidden'} 
        `}
        onClick={this.toggleSearch} 
      >
        <div
          class="qumra-search-input-container"
          onClick={this.preventClose} 
        >
          <input
            onSubmit={this.Search}
            onInput={this.handleInputChange}
            placeholder="ابحث هنا..."
            class="qumra-search-input"
          />
          <svg
            onClick={this.Search}
            style={{ cursor: 'pointer' }}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              class={"cursor-pointer"}
              d="M18 5C22.9706 5 27 9.02944 27 14C27 18.9706 22.9706 23 18 23C15.5144 23 13.2658 21.9937 11.636 20.364C10.0063 18.7342 9 16.4856 9 14C9 9.02944 13.0294 5 18 5ZM29 14C29 7.92487 24.0751 3 18 3C11.9249 3 7 7.92487 7 14C7 16.6771 7.95737 19.1321 9.54676 21.039L3.29289 27.2929C2.90237 27.6834 2.90237 28.3166 3.29289 28.7071C3.68342 29.0976 4.31658 29.0976 4.70711 28.7071L10.961 22.4532C12.8679 24.0426 15.3229 25 18 25C24.0751 25 29 20.0751 29 14Z"
              fill="white"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <svg
          class="qumra-close-button"
          onClick={this.toggleSearch} 
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.5" y="0.5" width="49" height="49" rx="24.5" stroke="white" />
          <path
            d="M33 17L17 33M33 33L17 17"
            stroke="white"
            stroke-width="3"
            stroke-linecap="round"
          />
        </svg>
      </div>
    );
  }
}
